// Helpers.
import _isEmpty from 'lodash/isEmpty';
import i18n from './reacti18n';
import Page from './page';

// BNA title short version threshold
export const bnaSectionTitleLimits = {
  desktop: 36,
  tablet: 36,
  mobile: 21,
};

export const callusMessage = (loggedOutMessage, loggedInMessage) =>
  document.body.getAttribute('isloggedin') ? loggedInMessage : loggedOutMessage;

// Returns display name all all markets the display name is firstName and only for JP market the display name is lastName
export const getDisplayName = () => {
  const userProfile = Page.getUserProfile();
  if (typeof userProfile === 'object') {
    if (Page.getCountry().toUpperCase() === 'JP') {
      return userProfile.lastName || '';
    }
    return userProfile.firstName || '';
  }
  return '';
};

/**
 *  Get BNA title as part of experiment
 *  If 'For {firstName}' length is less than the BNA title threshold then display 'For FirstName' if not just display 'For you'
 */
export const getBNATitle = () => {
  const displayName = getDisplayName();
  if (!_isEmpty(displayName)) {
    const bnaUserTitle = i18n.message('smarthelp/home.home.forUser', { name: displayName });
    if (bnaUserTitle.length <= bnaSectionTitleLimits[Page.getDeviceType()]) {
      return bnaUserTitle;
    }
  }
  return i18n.message('smarthelp/home.home.forYou');
};
